import { DatePicker, TimePicker } from '@mui/lab';
import { FormControl } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import { RadioGroup } from '@mui/material';
import { Radio } from '@mui/material';
import { Grid } from '@mui/material';
import { SubMenuFormVM } from 'civil-status/view-models/sub-menu-form';
import { DateTime } from 'luxon';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';

interface FormSubMenuPageProps {
  disabled?: boolean;
  values?: SubMenuFormVM;
  onChange: (key: keyof SubMenuFormVM, value: SubMenuFormVM[keyof SubMenuFormVM]) => void;
  onChanges: (values: SubMenuFormVM) => void;
}

const FormSubMenuPageComponent = ({
  disabled = false,
  values,
  onChange,
  onChanges,
}: FormSubMenuPageProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid
        item
        xs={12}
        md={3}
        sx={{
          paddingTop: '10px !important',
        }}
      >
        <FormControl component="fieldset">
          {"Inserimento dell'atto a posteriori?"}
          <RadioGroup
            row
            aria-label="Evento"
            id="happeInItaly"
            defaultValue={false}
            value={values?.isRear}
            onChange={() =>
              onChanges({
                isRear: !values?.isRear,
                date: DateTime.now(),
                time: DateTime.now(),
              })
            }
          >
            <FormControlLabel value="false" control={<Radio />} label="No" />
            <FormControlLabel value="true" control={<Radio />} label="Si" />
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data formazione"
          aria-label="Data formazione"
          value={values?.date || null}
          onChange={(date) => onChange('date', date)}
          disabled={disabled || !values?.isRear}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="date"
              fullWidth
              helperText=""
              // error={touched?.date && Boolean(errors?.date)}
              // helperText={errors?.date}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TimePicker
          label="Ora formazione"
          aria-label="Ora formazione"
          value={values?.time || null}
          onChange={(date) => {
            onChange('time', date);
          }}
          disabled={disabled || !values?.isRear}
          renderInput={(params) => (
            <PmiTextField
              id="time"
              {...params}
              fullWidth
              helperText=""
              // error={touched?.time && Boolean(errors?.time)}
              // helperText={errors?.time}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

FormSubMenuPageComponent.displayName = 'Form Sub Menu Page';

const FormSubMenuPage = memo(FormSubMenuPageComponent);
export default FormSubMenuPage;
